import * as Yup from "yup";

const required = () => Yup.string().required('Campo requerido');

export {required}